



























































import { Component, Vue } from 'nuxt-property-decorator';
import { loadJS } from '~/components/utils/browser/core';
import validate, { rules } from '~/components/utils/validate';
import BravadoTextInputV3 from '~/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import Modal from '~/components/common/Modal/Modal.vue';

@Component<ContactUsModal>({
  components: {
    Modal,
    BravadoTextInputV3,
    BravadoButtonV3,
  },
})
export default class ContactUsModal extends Vue {
  protected loaded = false;
  protected loading = false;
  protected email = '';
  protected message = '';
  protected errors = { email: undefined, message: undefined };

  get isLoading() {
    return this.loaded && !this.loading;
  }

  async handleOpen() {
    if (!this.loaded) {
      await loadJS(process.env.RECAPTCHA_URL);
      this.loaded = true;
    }
  }

  async handleSubmit() {
    if (!this.isLoading) return;

    const { errors, valid } = validate({
      email: rules.test(this.email, rules.email, 'Email address is invalid'),
      message: rules.test(this.message, rules.required, 'Message is required'),
    });

    this.errors = errors;

    if (!valid) return;

    try {
      this.loading = true;

      // @ts-ignore
      const token = await window.grecaptcha.execute(process.env.RECAPTCHA_TOKEN, { action: 'contact_us' });

      const { message } = await this.$api.$post('/profile/request_support.json', {
        contact_token: token,
        email: this.email,
        message: this.message,
      });

      this.$notice.success(message);
      this.$modal.hide();
      this.email = '';
      this.message = '';
    } catch (e) {
      this.$notice.error(e);
      this.$sentryUtils.error(e);
    } finally {
      this.loading = false;
    }
  }
}
